import JiraModal from "./JiraModal";

export default JiraModal;
